'use strict';

function CompanyCategoryService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/categories/:categoryId', {companyId: '@companyId', categoryId: '@id'}, {
    'update': { method:'PUT' }
  });
}

angular.module('dokiv')
  .factory('CompanyCategoryService', ['$resource', 'config', CompanyCategoryService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/categories/CompanyCategoryService.js
// module id = 13
// module chunks = 0